import MyMap from './MapComponents/MyMap';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
    return (
        <BrowserRouter>
            <MyMap />
            <ToastContainer position='top-right' />
        </BrowserRouter>
    );
};

export default App;
